import UpgradeTip from './UpgradeTip';

export { openUpgradeTip } from './UpgradeTip';

export type { IUpgradeBufferState } from './UpgradeTip';

export default UpgradeTip;
